/* src/app/shared/contract/contract-item/contract-cgrp-on/cgrp-on-managing-dialog/cgrp-on-managing-dialog.component.scss */
.mat-title,
.main-content-container,
.add-category-bloc-container > span:first-child {
  color: #001A33;
}
.container {
  max-height: calc(100dvh - 120px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 800px;
  margin: 0;
}
.container > :not(.dialog-form-content) {
  flex-shrink: 0;
}
.dialog-form-content {
  position: relative;
  flex-shrink: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.dialog-fields {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.85);
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
  margin-bottom: 10px;
}
.bloc-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.condition-inputs-container > .tv-container-select-white-rect-extensible,
.condition-inputs-container > .search-item-container {
  flex: 1 1 0;
  min-width: 0;
  width: 0;
}
.condition-inputs-container > .tv-container-select-white-rect-extensible mat-form-field,
.condition-inputs-container > .search-item-container mat-form-field {
  width: 100%;
}
.condition-inputs-container .search-item-container > .tv-rect-input-extensible {
  min-width: 0;
  width: 100%;
}
.condition-inputs-container > button {
  flex-shrink: 0;
}
.add-category-bloc-container {
  display: flex;
  gap: 10px;
  font: 400 14px FranceTV Brown;
  margin-left: 10px;
}
.add-category-bloc-container .type-icon {
  height: 16px;
}
.add-category-bloc-container .type-icon:hover {
  cursor: pointer;
}
.cond-container {
  max-height: 300px;
  overflow-y: auto;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.saving-content {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 260px;
  width: 100%;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.container-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 450px;
  margin: 0;
  border-radius: 25px;
  font-size: 13px;
}
.container-options .mat-checkbox-inner-container {
  width: 12px;
  height: 12px;
}
.container-options .search-container {
  margin: 12px 0px;
}
.container-options .full-width {
  width: 100%;
}
.container-options .checkbox-list {
  display: flex;
  gap: 10px;
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
  padding: 8px;
}
.container-options .button-group-horizontal {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.conditions-table-container {
  background-color: #FFF;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #DFEBF7;
}
.conditions-table-scroll {
  --condition-table-header-height: 40px;
  --condition-table-row-height: 40px;
  height: calc(var(--condition-table-header-height) + 5 * var(--condition-table-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.conditions-table {
  width: 100%;
  table-layout: fixed;
}
.conditions-table .mat-mdc-header-row {
  height: var(--condition-table-header-height);
}
.conditions-table .mat-mdc-row {
  height: var(--condition-table-row-height);
}
.conditions-table .mat-mdc-header-cell,
.conditions-table .mat-mdc-cell {
  padding-top: 0;
  padding-bottom: 0;
}
.conditions-table .mat-column-category {
  width: 27%;
}
.conditions-table .mat-column-number {
  width: 96px;
}
.conditions-table .mat-column-remove {
  width: 56px;
}
.condition-remove-icon {
  color: #0083FF;
}
.condition-cell-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.block-chip {
  display: flex;
  align-items: center;
  padding: 4px 7px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #6b90b3;
  color: #fff;
}
.block-chip .mat-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.block-chip .material-icons {
  font-size: 16px;
}
.block-chip .text {
  font-size: 12px;
  margin-right: 3px;
}
.tv-new-screen-information-input .mat-form-field-infix {
  font: 400 14px FranceTV Brown;
  color: #001a33;
  padding: 10px;
  width: 130px !important;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
/*# sourceMappingURL=cgrp-on-managing-dialog.component.css.map */
